export const site = process.env.SHELTER_SITE
  ? process.env.SHELTER_SITE.toLowerCase()
  : 'england';
export const country = site.replace(/^\w/, (c) => c.toUpperCase());
